<div class="ccm-permission-container" *ngIf="isModalOpened">
    <div class="ccm-permission-wrapper">
        <div class="ccm-permission-dialogue">
            <div class="text-icon-container">
                <div class="text-container">
                    <p class="fs-21 fw-700 lh-120 clr-303030">
                        {{title}}
                    </p>
                    <p class=" fs-12 lh-120 mt-3 clr-777">{{subTitle}}</p>
                </div>
                <div class="icon-box" (click)="closeDialog()">
                    <img class="pointer" src="/assets/icons/close-model-icon.svg" alt="Close" width="16" />
                </div>
            </div>
            <div class="horizontal-divider"></div>

            <ng-container #ContainerInfo>
                <!-- Always keep the Chatting_Board in DOM -->
                <ng-container *ngTemplateOutlet="Chatting_Board"></ng-container>

                <!-- Greeting overlay only shows if no chat messages -->
                <div *ngIf="chatMessages.length === 0" class="greeting-overlay">
                    <ng-container *ngTemplateOutlet="Greeting_Screen"></ng-container>
                </div>
            </ng-container>


            <div class="input-wrapper">
                <div class="container-wrapper">
                    <input #chatInput type="text" id="text-ai-promts" [(ngModel)]="userPrompts" name="text-ai-promts" class="text-content" placeholder="What’s on your mind?"
                        (input)="onPromptChange()" (keyup.enter)="handleSendButton()" />

                    <button class="btn-send" (click)="handleSendButton()" [disabled]="isSendDisabled" [class.disabled]="isSendDisabled">
                        <img src="/assets/icons/btn-ai-icon.svg" alt="btn">
                    </button>

                </div>
            </div>

        </div>
    </div>
</div>



<ng-template #Greeting_Screen>
    <div class="greeting-continer">
        <div class="greeting-text">
            <span class="user-name">{{ userInfo.fullName }} !</span>
            Welcome to Fusion AI
        </div>

        <div class="ai-icons-msg">
            <img src="../../../../assets/icons/chatbot-ai-msg.svg" alt="icons">
            <div>Got questions? I’ve got answers.</div>
        </div>
    </div>

    <div class="prompt-container">
        <span class="text-promt">Choose a prompt to start</span>
        <div class="promts-btns-container">
            <div class="btn-wraper" (click)="handleButtonClick('summary')">
                <div class="btn-contnet">

                    <img src="/assets/icons/bug-ai.svg" alt="">

                    <span class="text">Summary</span>
                </div>
            </div>
            <div class="btn-wraper" (click)="handleButtonClick('ai')">
                <div class="btn-contnet">

                    <img src="/assets/icons/ai-assiestant.svg" alt="">

                    <span class="text">AI Assistant</span>
                </div>
            </div>
            <div class="btn-wraper" (click)="handleButtonClick('visualization')">
                <div class="btn-contnet">

                    <img src="/assets/icons/visulaization.svg" alt="">

                    <span class="text">Visualization</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #Chatting_Board>
    <div class="chat_board">


        @for (chat of chatMessages; track $index) {

        <!-- USER QUESTION -->

        @if (chat.type === 'user') {
        <div class="chat-user">
            <div class="bubble" [innerHTML]="chat.formattedHtml"></div>
        </div>
        }

        <!-- BOT ANSWER -->
        @if(chat.type === 'bot'){
        <div class="chat-bot">
            <div class="text-chart-wrapper">

                @if(chat.chart){
                <div class="chart">
                    <canvas [id]="'chart-' + $index" height="350"></canvas>
                </div>
                }

                <div class="bubble" [innerHTML]="chat.formattedHtml"></div>
            </div>
        </div>
        }


        @if (chat.type === 'thinking') {
        <div class="thinking-ai-state">
            <img src="/assets/icons//thinking-ai.svg" alt="thinking" class="thinking-icon">
            <span class="thinking-text">Thinking</span>
        </div>
        }

        @if (chat.type === 'error') {
        <div class="chat-bot chat-error">
            <div class="bubble" [innerHTML]="chat.formattedHtml"></div>
        </div>
        }
        }


    </div>
</ng-template>